export default __webpack_public_path__ + "static/media/pcb.b6efc043.webp";